module.exports = __webpack_public_path__ + "img/atyphoon.b4f30abe.png";